<template>
	<div class="knowledge_container full flex">
		<div class="tinymce">
			<tinymce :menubar="true" :toolbar="toolbar" :plugins="plugins" v-model="comment"></tinymce>
		</div>
	</div>
</template>
<style scoped>
	.knowledge_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tinymce {
		position: relative;
		width: 100%;
		height: 500px;
	}
</style>
<script>
	import tinymce from '@_system/components/tinymce.vue'
	import listBase from '@_system/components/base/list.vue'
	// import knowledgeTree from '@_system/components/formcomponents/common/select/knowledge/tree.vue'
	export default {
		extends: listBase,
		name: 'knowledgeIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-row>
					<el-button size="mini" type="primary" onClick={this.addlist}>添加</el-button>
					<el-button size="mini" type="success" onClick={this.editlist}>修改</el-button>
					<el-button size="mini" type="danger" onClick={this.dellist}>删除</el-button>
				</el-row>
			]
			this.$slots.aside = [<knowledge-tree ref="knowledgetTree" key={this.knowledgetTreeKey} onSelect={this.knowledgetTreeChange} />]


			return listBase.render.call(this, h)
		},
		data() {
			return {
				plugins: 'customPlugin print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help emoticons autosave bdmap indent2em formatpainter axupimgs',
				
				toolbar: 'custompreview code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
    styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
    table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs',
				// plugins:'customPlugin',
				// toolbar:'custompreview',
				
				componenttype: 'system',
				moduleName: 'knowledge',
				windowName: '知识库',
				knowledgeid: 0,
				knowledgename: '',
				field: '',
				knowledgetTreeKey: Math.random(),
				listformData: {
					name: 'knowledgelist',
					id: 0,
					controlltype: 1,
					show: false
				},
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			beforeCreateGrid(formConfig, columns, gridOptions) {
				gridOptions.pagerConfig.enabled = false
			},
			knowledgetTreeChange(e) {
				this.knowledgeid = e.id
				this.knowledgename = e.name
				this.field = e.field
				this.customreload()
			},
			beforeRequest(form, page) {
				form.onwerid = this.knowledgeid
				page.currentPage = -1
			},
			addlist() {
				// import('@_system/components/forms/knowledgelist/form.vue').then((res) => {
				// 	this.formModule = {
				// 		component: res.default,
				// 		name: 'knowledgelist',
				// 		id: 0,
				// 		controlltype: 1,
				// 		show: true
				// 	}
				// })
			},
			editlist() {
				// if (this.knowledgeid != 0) {
				// 	import('@_system/components/forms/knowledgelist/form.vue').then((res) => {
				// 		this.formModule = {
				// 			component: res.default,
				// 			name: 'knowledgelist',
				// 			id: this.knowledgeid,
				// 			controlltype: 2,
				// 			show: true
				// 		}
				// 	})
				// } else {
				// 	this.$message.error({
				// 		message: '请选择枚举',
				// 	})
				// }

			},
			add() {
				// let data = this.$refs[this.moduleName + '_list'].getData()
				// import('@_system/components/forms/knowledge/form.vue').then((res) => {
				// 	this.formModule = {
				// 		component: res.default,
				// 		name: 'knowledge',
				// 		id: 0,
				// 		controlltype: 1,
				// 		show: true,
				// 		foreingKey: {
				// 			parentid: e ? e.id : null,
				// 			onwerid: this.knowledgeid
				// 		},
				// 		extra: {
				// 			lastvalue: data.length == 0 ? 1 : data[data.length - 1]['value'] + 1,
				// 			title: e ? '枚举【父级:' + e.label + '】' : null,
				// 			field: this.field
				// 		}
				// 	}
				// })
			},
			edit() {
				// import('@_system/components/forms/knowledge/form.vue').then((res) => {
				// 	this.formModule = {
				// 		component: res.default,
				// 		name: 'knowledge',
				// 		id: row.id,
				// 		controlltype: 2,
				// 		show: true,
				// 		foreingKey: {
				// 			parentid: row ? row.parentid : null,
				// 			onwerid: this.knowledgeid
				// 		},
				// 		extra: {
				// 			field: this.field
				// 		}
				// 	}
				// })


			},
			del(row) {
				this.$confirm('是否删除 ' + row.label, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.knowledge.delete(row.id, {
						onwerid: this.knowledgeid
					}).then(() => {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					})
				}).catch(() => {

				})


			},
			dellist() {
				if (this.knowledgeid != 0) {
					this.$confirm('是否删除 ' + this.knowledgename, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$api.knowledgelist.delete(this.knowledgeid).then(() => {
							this.$message({
								message: '操作成功',
								type: 'success'
							})
							this.knowledgetTreeKey = Math.random()
						})
					}).catch(() => {

					})
				} else {
					this.$message.error({
						message: '请选择枚举',
					})
				}

			},
			formBack(e) {
				let component = this.formModule.component
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
				if (e.type != 'cancle') {
					if (component.name == 'knowledgeForm') {
						this.customreload()
					} else {
						this.reloadlist()
					}
				}

			},
			reloadlist() {
				this.knowledgetTreeKey = Math.random()
			}
		},
		components: {
			// knowledgeTree,
			tinymce

		}
	}
</script>